var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// ABZ Testimonial

$(document).ready(function(){
  $("#testimonial").owlCarousel(
    {
      autoplay: true,
      margin: 15,
      dots: true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:3
          }
      }
    }
  );
});